import React from "react";
import { Field } from "react-final-form";
import { TextField } from "@mui/material";
import RffInputWrapper from "../shared/RffInputWrapper";

const formatPhone = (raw) => {
  if (!raw) return "";
  const digits = String(raw).replace(/\D/g, "").slice(0, 10);
  const a = digits.slice(0, 3);
  const b = digits.slice(3, 6);
  const c = digits.slice(6, 10);
  if (digits.length > 6) return `(${a}) ${b}-${c}`;
  if (digits.length > 3) return `(${a}) ${b}`;
  if (digits.length > 0) return `(${a}`;
  return "";
};

const RffPhoneField = ({
  name,
  label,
  required = false,
  helperText,
  placeholder = "(555) 555-5555",
  fullWidth = true,
  row = false,
  suppressGrid,
  size,
  disabled,
}) => (
  <RffInputWrapper
    label={label}
    suppressGrid={suppressGrid}
    size={size}
    helperText={helperText}
    required={required}
    row={row}
  >
    <Field
      name={name}
      validate={(v) => {
        if (required && (v == null || v === "")) return "This field is required";
        if (v && String(v).replace(/\D/g, "").length !== 10) {
          return "Enter a 10-digit phone number";
        }
        return undefined;
      }}
      parse={(v) => (v ? String(v).replace(/\D/g, "") : undefined)}
      format={formatPhone}
      formatOnBlur={false}
      render={({ input, meta }) => (
        <TextField
          {...input}
          placeholder={placeholder}
          disabled={disabled}
          fullWidth={fullWidth}
          error={meta.touched && !!meta.error}
          helperText={meta.touched && meta.error ? meta.error : null}
        />
      )}
    />
  </RffInputWrapper>
);

export default RffPhoneField;
